import { render } from "./IconCross.vue?vue&type=template&id=53157c04"
const script = {}
script.render = render

export default script